
import { Component, Prop, Vue } from "nuxt-property-decorator";
import LoadingSpinner from "~/components/molecules/display/LoadingSpinner.vue";

@Component({
  components: {
    LoadingSpinner,
  },
})
export default class PriceTrendSection extends Vue {
  @Prop({ type: Boolean, default: false }) readonly isLoading!: boolean;
  @Prop({ type: Boolean, default: true }) readonly hasData!: boolean;
}
